// extracted by mini-css-extract-plugin
export default {"base":"vp_XLGt9","figure":"vp_HQCK0","image":"vp_CUIr8","title":"vp_QJE5u","content":"vp_BnjqY"};